module.exports = __webpack_public_path__ + "assets/img/goods-demo02.7a2da2b2.png";